import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PerfilService } from 'src/app/services/perfil.service';
import { PerfilNormalizado } from '../../enums/perfil-normalizado.enum';

@Injectable({
    providedIn: 'root'
})
export class CartoesFisicosGuard implements CanActivate {
    constructor(
        private router: Router,
        private perfilService: PerfilService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentPerfis = this.perfilService.currentPerfisValue;
        if (currentPerfis) {
            if (currentPerfis.some(x => x.nomeNormalizado === PerfilNormalizado.CartaoFisico) || currentPerfis.some(x => x.nomeNormalizado === PerfilNormalizado.Responsavel)) {
                return true;
            }
        }

        this.router.navigate(['accessdenied']);
        return false;
    }
}
